export const inventoryStatusKeys = {
  all: ['inventory_status'] as const,
  many: (queryProps?: Record<string, unknown>, type = 'list') =>
    [...inventoryStatusKeys.all, type, ...[queryProps]].filter(Boolean),
  one: (id: number) => [...inventoryStatusKeys.all, 'detail', id] as const,
};
